const routes = [
  {
    path: '/referral',
    component: () => import('@/views/provider/referral-management/Wrapper.vue'),
    children: [
      {
        path: 'search',
        name: 'referral-search',
        component: () =>
          import('@/views/provider/referral-management/search/Master.vue'),
      },
      {
        path:
          'documentHistory/:studentServiceId/:allowAddDocument/:companyId/:admissionId/:isInterventionPlan/:academicYearId/:showReplacement',
        name: 'documentHistory',
        component: () =>
          import(
            '@/views/provider/referral-management/search/DocumentHistory.vue'
          ),
      },
      {
        name: 'ReferralRecord',
        path: ':studentServiceId/record',
        component: () =>
          import('@/views/provider/referral-management/search/Record.vue'),
      },
      {
        name: 'AppointmentRecord',
        path: ':clientAppointmentId/record-appointment',
        component: () =>
          import(
            '@/views/provider/referral-management/search/RecordAppointment.vue'
          ),
      },
      {
        path: 'admissionManagement/:admissionId',
        name: 'admissionManagement',
        component: () =>
          import(
            '@/views/provider/referral-management/search/AdmissionManagement.vue'
          ),
        props: true,
      },
      {
        path: 'history/:admissionId/:referralNumber',
        name: 'referralHistory',
        component: () =>
          import('@/views/provider/referral-management/ReferralHistory'),
      },
      {
        path:
          'interventionPlan/:admissionId/:academicYearId?/:dateIntervention?/:interventionPlanId?/:onlyShowPlan?',
        name: 'interventionPlan',
        component: () =>
          import(
            '@/views/provider/referral-management/search/InterventionPlan.vue'
          ),
      },
      {
        path:
          'achievement-summary/:admissionId/:academicYearId/:interventionPlanId',
        name: 'achievementSummary',
        component: () =>
          import(
            '@/views/provider/referral-management/search/InterventionPlan.vue'
          ),
        props: { achievementSummary: true },
      },
      {
        path: 'admissionNote/:admissionId',
        name: 'admissionNote',
        component: () =>
          import(
            '@/views/provider/referral-management/search/AdmissionNote.vue'
          ),
      },
      {
        path: 'resultsSummary/:admissionId',
        name: 'resultsSummary',
        component: () =>
          import(
            '@/views/provider/referral-management/search/ResultsSummary.vue'
          ),
      },
      {
        path: 'resultsSummary/history/:admissionId',
        name: 'resultsSummaryHistory',
        component: () =>
          import(
            '@/views/provider/referral-management/search/ResultsSummaryHistory.vue'
          ),
      },
      {
        path: 'amended-plan-history/:admissionId/:interventionPlanId',
        name: 'amendedPlanHistory',
        component: () =>
          import(
            '@/views/provider/referral-management/search/AmendedPlanHistory.vue'
          ),
      },
      {
        path: 'amended-note-history/:admissionId',
        name: 'amendedNoteHistory',
        component: () =>
          import(
            '@/views/provider/referral-management/search/AdmissionNoteAmended.vue'
          ),
      },
      // JSF: CompensatoryRequestFromReferralManagement: this is only for keeping the search result (persistence data) when navigating from the referral management search.
      {
        path: '/provider/compensatoryservice/request',
        name: 'CompensatoryRequestFromReferralManagement',
        component: () =>
          import('@/views/provider/compensatoryService/RequestWrapper.vue'),
      },
      {
        path: 'signature-hub/:typeId/:relatedId',
        name: 'SignatureHub',
        component: () => import('@/views/provider/signature-hub/Main.vue'),
      },
    ],
  },
];

export default routes;
